import { SelectField } from '#app/components/form/select-field.tsx'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { TRAINING_RECORD_RETENTION_OPTIONS } from '#app/routes/mocra+/_form+/intake-options.ts'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'
import { type TrainingDocumentationFormValues } from '#app/routes/mocra+/_form+/training-documentation.tsx'

type RecordRetentionValue = TrainingDocumentationFormValues['recordRetention']

type Props = {
	readonly resources: SectionResources
	readonly value: RecordRetentionValue
	readonly errors: readonly string[]
	readonly onChange: (value: RecordRetentionValue) => void
}

export function RecordRetentionSection({
	resources,
	value,
	errors,
	onChange,
}: Props) {
	return (
		<Section
			title="Record retention"
			description="Set the retention target for training records so we can reference it in the SOP and inspection scripts."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
			childrenClassName="space-y-4"
		>
			<SelectField
				labelProps={{
					children: 'How long do you keep training records?',
				}}
				selectProps={{
					value,
					onChange: (event) => onChange(event.target.value),
					onValueChange: (next) => onChange(next),
				}}
				options={TRAINING_RECORD_RETENTION_OPTIONS}
				errors={errors.length > 0 ? [...errors] : undefined}
			/>
		</Section>
	)
}
